import charts from "./echarts.vue";
import breadcrumb from "./breadcrumb.vue";
import modelFrom from "./model-from.vue";
import roundModel from "./roundModel.vue";
import squareModel from "./squareModel.vue";

import roundModelSingle from "./roundModelSingle.vue";
import squareModelSingle from "./squareModelSingle.vue";

const component = {
  install: function (Vue) {
    Vue.component("charts", charts);
    Vue.component("breadcrumb", breadcrumb);
    Vue.component("modelFrom", modelFrom);
    Vue.component("roundModel", roundModel);
    Vue.component("squareModel", squareModel);

    Vue.component("squareModelSingle", squareModelSingle);
    Vue.component("roundModelSingle", roundModelSingle);
  },
};

export default component;
